import { useQuery } from '@tanstack/react-query';
import { transformKeysToCamelCase } from '../../utils/caseTransformers';
import {
  AzureDevOpsClient,
  AvailableRepositoriesResponse,
} from '../httpClients/AzureDevOpsClient';
import { QUERY_KEYS } from './consts';
import type { UseQueryOptions } from '@tanstack/react-query';

type OmittedQueryOptions = Omit<
  UseQueryOptions<AvailableRepositoriesResponse>,
  'queryKey' | 'queryFn'
>;

type UseAvailableAzureRepositoriesQueryParams = {
  installationId?: string;
  forceRefresh?: boolean;
  connectionMethod?: string | null;
  azureTenantId?: string;
  options?: OmittedQueryOptions;
};

export const useAvailableAzureRepositoriesQuery = (
  params?: UseAvailableAzureRepositoriesQueryParams,
) => {
  const forceRefresh = params?.forceRefresh ?? false;
  const installationId = params?.installationId;
  const connectionMethod = params?.connectionMethod;
  const azureTenantId = params?.azureTenantId;
  const options = params?.options;

  return useQuery({
    queryKey: [
      QUERY_KEYS.AZURE_AVAILABLE_REPOSITORIES,
      installationId,
      connectionMethod,
      azureTenantId,
    ],
    queryFn: () =>
      AzureDevOpsClient.getAvailableRepositories(
        forceRefresh,
        connectionMethod,
        azureTenantId,
      ),
    select: (data) =>
      transformKeysToCamelCase<AvailableRepositoriesResponse>(data),
    placeholderData: (previousData) => previousData,
    ...options,
  });
};
